

import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Addresses


export interface Address {
    id: ID;

    
    address?: string;

    
    city?: string;

    
    country?: string;

    
    email?: string;

    
    phone?: string;

    
    mobilePhone?: string;

    
    description?: string;

    
    scopeGroupId: ID;

    }




export interface CreateAddress {
    
    address?: string;

    
    city?: string;

    
    country?: string;

    
    email?: string;

    
    phone?: string;

    
    mobilePhone?: string;

    
    description?: string;

    
    }


export interface UpdateAddress {
    
    address?: string;

    
    city?: string;

    
    country?: string;

    
    email?: string;

    
    phone?: string;

    
    mobilePhone?: string;

    
    description?: string;

    
    }

export interface PresentationAddressRequest {
    list: ListRequest,
    filter: {
        email: string,
        emailOr: boolean,
        address: string,
        addressOr: boolean,
        city: string,
        cityOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryAddress {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Address): PrimaryAddress | undefined {
        return entity ? new PrimaryAddress(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryAddress {
        return new PrimaryAddress(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryAddress {
        let vals = path?.split('/');
        return new PrimaryAddress(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryAddress[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Address): string {
    let fields = entity ? [
    entity.email,
            entity.address,
            entity.city,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityAddress {
    id: PrimaryAddress;
    data: UpdateAddress;


    constructor(id: PrimaryAddress, data: UpdateAddress) {
        this.id = id;
        this.data = data;
    }
}
